import { BASE_URL } from "./helpers/consts";

export function getIndexSchema() {
  return {
    "@type": "ApartmentComplex",
    "name": "ЖК Новый Фамильный",
    "url": BASE_URL,
    "description": "Новый формат комфорта в Зеленой роще",
    "image": [
      BASE_URL + 'schema/schema-complex.jpg',
    ],
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "ул. Обская, 7",
      "addressLocality": "Уфа",
      "addressRegion": "Республика Башкортостан",
      "postalCode": "450022",
      "addressCountry": "RU"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "54.716492",
      "longitude": "55.999627"
    },
    "developer": {
      "@type": "Organization",
      "name": "Агидель-ИнвестСтрой"
    }
  }
}
